import { useEffect, useState } from "react";
import type { Call } from "../../api/types";
import { useTill } from "../../app/till-context";
import { t } from "../../i18n";
import { formatPhone } from "../../lib/phone";
import { formatTime } from "../../lib/time";
import { Dialog } from "../../ui/Dialog";

interface Props {
  /** "Overnemen": the call's number on the ticket. */
  onTake: (call: Call) => void;
  onClose: () => void;
}

/** De Bellerslijst (F10, prototype openCalls): today's calls with the customer, newest first. */
export function CallsDialog({ onTake, onClose }: Props) {
  const { api, report, callsRevision } = useTill();
  const [calls, setCalls] = useState<Call[] | null>(null);
  const text = t.calls;

  // live: a new call or one taken on another till shows at once
  useEffect(() => {
    let current = true;
    api
      .request<{ calls: Call[] }>("GET", "/device/calls", { retry: true })
      .then((answer) => {
        if (current) setCalls(answer.calls);
      })
      .catch(report);
    return () => {
      current = false;
    };
  }, [api, report, callsRevision]);

  return (
    <Dialog title={text.list} onClose={onClose}>
      {calls !== null &&
        (calls.length === 0 ? (
          <p className="note">{text.empty}</p>
        ) : (
          <div className="tablewrap">
            <table>
              <thead>
                <tr>
                  <th>{text.columns.time}</th>
                  <th>{text.columns.number}</th>
                  <th>{text.columns.customer}</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {calls.map((call) => (
                  <tr key={call.id}>
                    <td className="num">{formatTime(call.at)}</td>
                    <td className="num">{formatPhone(call.phone)}</td>
                    <td>
                      {call.customer
                        ? text.listCustomer(call.customer.name, call.customer.orders, call.customer.platform)
                        : text.listUnknown}
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn small"
                        onClick={() => {
                          onTake(call);
                        }}
                      >
                        {text.take}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
    </Dialog>
  );
}
